import { useEffect, useState } from 'react';
import { useFavorites } from '@/store/useFavorites';
import { ListingCard } from '@/components/common/ListingCard';
import { EmptyState } from '@/components/common/EmptyState';
import { SkeletonGrid } from '@/components/common/SkeletonCard';
import { getListingsByIds } from '@/services/api';
import { Heart } from 'lucide-react';

export default function SavedHomes() {
  const getIds = useFavorites((s) => s.getIds);
  const [homes, setHomes] = useState(null);
  const favIds = getIds();

  useEffect(() => {
    if (favIds.length > 0) {
      getListingsByIds(favIds).then(setHomes);
    } else {
      setHomes([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favIds.length]);

  return (
    <div>
      <h1 className="font-display text-2xl font-semibold text-slate-900">Saved homes</h1>
      <p className="text-sm text-slate-600">{favIds.length} home{favIds.length !== 1 ? 's' : ''} saved</p>
      <div className="mt-6">
        {homes === null ? <SkeletonGrid count={3} /> : homes.length === 0 ? (
          <EmptyState icon={Heart} title="No saved homes yet" description="Tap the heart on any listing to save it here for later." actionLabel="Browse homes" onAction={() => (window.location.href = '/listings')} />
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">{homes.map((l) => <ListingCard key={l.id} listing={l} />)}</div>
        )}
      </div>
    </div>
  );
}
